import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaHome, FaChevronRight } from 'react-icons/fa'
import {
  BreadcrumbNav,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbHome,
  BreadcrumbSeparator,
} from './styles'
import { buildBreadcrumbs, HOME_PATH } from './breadcrumbRoutes'

/**
 * The trail for the current screen, shown in the topbar beside the user block.
 *
 * Every crumb is a link, the current screen included - it reloads that section,
 * which is what is expected when the whole trail is clickable.
 */
const Breadcrumbs = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const crumbs = buildBreadcrumbs(location.pathname)
  const onHome = location.pathname === HOME_PATH

  return (
    <BreadcrumbNav aria-label="Breadcrumb">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbHome
            type="button"
            title="Dashboard"
            aria-label="Dashboard"
            aria-current={onHome ? 'page' : undefined}
            onClick={() => navigate(HOME_PATH)}
          >
            <FaHome />
          </BreadcrumbHome>
        </BreadcrumbItem>

        {crumbs.map((crumb, index) => (
          <BreadcrumbItem key={crumb.path}>
            <BreadcrumbSeparator aria-hidden="true">
              <FaChevronRight />
            </BreadcrumbSeparator>
            <BreadcrumbLink
              type="button"
              title={crumb.label}
              aria-current={index === crumbs.length - 1 ? 'page' : undefined}
              onClick={() => navigate(crumb.path)}
            >
              {crumb.label}
            </BreadcrumbLink>
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </BreadcrumbNav>
  )
}

export default Breadcrumbs
